// Source - https://stackoverflow.com/a/65985736
// Posted by Nicolas Maloeuvre
// Retrieved 2026-05-18, License - CC BY-SA 4.0

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.querySelectorAll('a').forEach(function(link) {
      if (link.host !== window.location.host) {
        link.target = "_blank"
      }
    })
  }
}
